import type { HeroBanner as HeroBannerData } from '@entities/home'
import { Button } from '@shared/ui/button'
import { Link } from '@tanstack/react-router'

interface HeroBannerProps {
  readonly banner: HeroBannerData
}

export function HeroBanner({ banner }: HeroBannerProps) {
  return (
    <div className="px-page-x pt-4">
    <div className="relative overflow-hidden rounded-2xl bg-bg-raised" style={{ aspectRatio: '4 / 3' }}>
      {/* Background gradient */}
      <div className={`absolute inset-0 bg-gradient-to-r ${banner.gradient}`} />

      {/* Character image */}
      <img
        src={banner.image}
        alt=""
        aria-hidden="true"
        draggable={false}
        className="absolute inset-0 h-full w-full object-cover"
      />

      {/* Left fade for text readability */}
      <div className="absolute inset-y-0 left-0 w-2/3 bg-gradient-to-r from-bg-raised via-bg-raised/60 to-transparent" />

      {/* Text content */}
      <div className="absolute inset-y-0 left-0 flex flex-col justify-start gap-2.5 p-page-x pt-8">
        <span className="w-fit rounded-full bg-primary/15 px-2.5 py-0.5 typo-footnote font-semibold text-primary">
          {banner.tag}
        </span>
        <h2 className="typo-heading font-bold text-foreground whitespace-pre-line">
          {banner.title}
        </h2>
        <p className="typo-caption text-muted-foreground">{banner.description}</p>
        <Link to="/saju/$sajuType" params={{ sajuType: 'classic' }}>
          <Button variant="primary" size="default" className="mt-1 w-fit">
            {banner.cta}
          </Button>
        </Link>
      </div>
    </div>
    </div>
  )
}
